import { Component, ChangeDetectionStrategy, inject} from '@angular/core';
import { Router } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { AuthSessionService } from '../../../services/auth-session.service';
import { ErrorStateComponent } from '../error-state/error-state.component';

@Component({
    selector: 'gcp-workspace-error',
    templateUrl: './error.component.html',
    styleUrl: './error.component.scss',
    imports: [ErrorStateComponent, MatButton],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
  private readonly router = inject(Router);
  private readonly authSession = inject(AuthSessionService);

  goToHome() {
    void this.router.navigate(['/home']);
  }

  signOut(): void {
    this.authSession.logout();
  }
}
